module.exports = __webpack_public_path__ + "static/prosthetic_limb-a33d3554dcb470732949acbc56a8d649.jpg";